import { useParams, Link } from "react-router";
import { useTranslation } from "react-i18next";
import { ConversationView } from "../components/chat/ConversationView";



export const ChatConversationPage = () => {
  const { t } = useTranslation();
  const { conversationId } = useParams<{ conversationId: string }>();

  if (!conversationId) {
    return (
      <div className="text-muted-foreground rounded-lg border p-6 text-sm">
        {t("chat.notFound", "Conversation introuvable.")}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Link
        to="/chat"
        className="text-muted-foreground hover:text-foreground text-sm underline-offset-4 hover:underline"
      >
        ← {t("chat.backToList", "Retour aux messages")}
      </Link>
      <div className="h-[calc(100vh-9.5rem)] min-h-[420px]">
        <ConversationView conversationId={conversationId} />
      </div>
    </div>
  );
}
